module.exports = __webpack_public_path__ + "img/login_logo_nisum.248039c4.webp";